import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const MoreInfo = styled(Typography.Caption)`
  padding: 20px 15px;
  text-align: center;

  a {
    text-decoration: underline;
  }
`;
